/**
 * Загрузка вложений (изображений) для markdown-полей.
 *
 * Отдельно от `apiRequest`, т.к. тело — `multipart/form-data` (FormData),
 * а не JSON. CSRF-токен берём из общего кэша client.ts; на 403 сбрасываем
 * и делаем один повтор (как в apiRequest).
 */
import { ApiError, getCsrfToken, resetCsrfToken } from './client.ts';

export interface UploadedAttachment {
  id: string;
  spaceId: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
  /** Относительный URL вида `/api/spaces/{spaceId}/attachments/{id}`. */
  url: string;
}

export async function uploadAttachment(spaceId: string, file: File): Promise<UploadedAttachment> {
  const url = `/api/spaces/${spaceId}/attachments`;
  const send = async (): Promise<Response> => {
    const form = new FormData();
    form.append('file', file, file.name);
    // Content-Type НЕ выставляем вручную — браузер сам добавит boundary.
    return fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'X-CSRF-Token': await getCsrfToken() },
      body: form,
    });
  };

  let res = await send();
  if (res.status === 403) {
    resetCsrfToken();
    res = await send();
  }
  if (!res.ok) {
    let body: { code: string; message: string } = {
      code: 'upload_failed',
      message: `HTTP ${res.status}`,
    };
    try {
      const j = (await res.json()) as { error?: { code: string; message: string } };
      if (j?.error) body = j.error;
    } catch {
      /* тело не JSON — оставляем дефолт */
    }
    throw new ApiError(res.status, body);
  }
  return (await res.json()) as UploadedAttachment;
}
